import { apolloClient } from '~/apollo-client';
import { BillingDataSource, EnrollmentDataSource } from '~/typings/context';
import {
  Flex_FetchPlanTemplateQuery,
  Flex_FetchPlanTemplateQueryVariables,
} from '~/typings/graphql';
import { trackError } from '~/utils/tracking';
import { FETCH_PLAN_TEMPLATE } from './fetch-plan-template.queries';

export const fetchPlanTemplate = async (
  params: FetchPlanTemplateParams,
): Promise<FetchPlanTemplateResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchPlanTemplateQuery,
    Flex_FetchPlanTemplateQueryVariables
  >({
    query: FETCH_PLAN_TEMPLATE,
    variables: {
      id: params.id,
    },
  });

  const billingOption = data.planTemplate.billingExperienceType as BillingDataSource;
  const enrollmentOption = data.planTemplate.enrollmentDataSourceName as EnrollmentDataSource;

  if (!billingOption || !enrollmentOption) {
    const error = new Error(`Failed to exchange plan template id ${params.id} for datasources`);
    trackError(error);
    throw error;
  }

  return {
    billingExperienceOptions: [billingOption],
    enrollmentOptions: [enrollmentOption],
    products: data.planTemplate.products,
  };
};

export type FetchPlanTemplateParams = {
  id: number;
};

export interface FetchPlanTemplateResponse {
  billingExperienceOptions: BillingDataSource[];
  enrollmentOptions: EnrollmentDataSource[];
  products: { id: number; productType: 'VNM' | 'BillPayService' | string }[];
}
